import { render, staticRenderFns } from "./ShowExercise.vue?vue&type=template&id=5cd93714&"
import script from "./ShowExercise.vue?vue&type=script&lang=js&"
export * from "./ShowExercise.vue?vue&type=script&lang=js&"
import style0 from "./ShowExercise.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports